// extracted by mini-css-extract-plugin
export var root = "BackgroundBlock-module--root--Z-WPt";
export var imgItem = "BackgroundBlock-module--img-item--2ngMk";
export var container = "BackgroundBlock-module--container--1G1Qe";
export var mobileContainer = "BackgroundBlock-module--mobile-container--12Iqr";